<div class="root" #root>
    @if (percent < 100) {
        <div class="progress">
            <mat-progress-bar mode="determinate" [value]="percent"></mat-progress-bar>
        </div>
    }
    <img
        #img
        src="{{ asset.image }}"
        (mousedown)="mouseDown($event)"
        (mousemove)="mouseMove($event)"
        (panstart)="panStart($event)"
        (panmove)="panMove($event)"
        (pinchin)="pinchZoom($event)"
        (pinchout)="pinchZoom($event)"
        (pinchend)="pinchEnd($event)"
        (pinchcancel)="pinchEnd($event)"
        (wheel)="zoom($event)"
    />
    <canvas #canvas width="{{ width }}" height="{{ height }}"></canvas>
</div>
